module.exports = __webpack_public_path__ + "e6d42b317a88d26f196f8195d499fcf5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-4.png
// module id = 1512
// module chunks = 0